import React from 'react';
import {useScrollSpy} from '@di-shared/features/common/ScrollSpyProvider';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {BrandType} from '@shared/cci/features/const/environment';

export default function (): JSX.Element {
  const {t} = useInferableTranslation();
  const {sectionTo, getSectionProps, getSectionHeaderProps} = useScrollSpy();

  // KIA: 주행기록, 안전운전점수, 소모품, 차량진단(차량인증등급 제외) 지원
  // HYUNDAI, GENESIS: 주행기록, 안전운전점수, 소모품, 차량진단 지원
  const TABS = [
    {value: 'driving', label: t('T10000')},
    {value: 'score', label: t('T40004')},
    {value: 'sest', label: t('T40005')},
    {value: 'diag', label: t('T40006')},
  ] as const;

  return (
    <>
      <div
        className="tabbar_txt tabbar_sticky"
        role="tablist"
      >
        <div className="inner">
          {TABS.map((tab) => (
            <button
              key={tab.value}
              type="button"
              className="tabbar_item body_large_r"
              {...getSectionHeaderProps(tab.value)}
              onClick={() => sectionTo(tab.value)}
              id={`${tab.value}_tab`}
              role="tab"
              aria-controls={`${tab.value}_tabpanel`}
            >
              <span className="txt">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="tab_content">
        <section
          className="section data_explore_section"
          {...getSectionProps(TABS[0].value)}
        >
          <h3 className="title_xsmall_b">{TABS[0].label}</h3>
          <div
            className="data_explore_content"
            role="group"
          >
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T40007')}
            </p>
            <div className="section_container">
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40009')}</li>
                <li className="data_item">{t('T40010')}</li>
                <li className="data_item">{t('T40011')}</li>
                <li className="data_item">{t('T40012')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40014')}</li>
                <li className="data_item">{t('T40015')}</li>
                <li className="data_item">{t('T40016')}</li>
                <li className="data_item">{t('T40017')}</li>
              </ul>
            </div>
          </div>
        </section>
        <div className="divider divider_thick" />
        <section
          className="section data_explore_section"
          {...getSectionProps(TABS[1].value)}
        >
          <h3 className="title_xsmall_b">{TABS[1].label}</h3>
          <div
            className="data_explore_content"
            role="group"
          >
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T40018')}
            </p>
            <div className="section_container">
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40019')}</li>
                <li className="data_item">{t('T40020')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40021')}</li>
                <li className="data_item">{t('T40004')}</li>
              </ul>
            </div>
          </div>
        </section>
        <div className="divider divider_thick" />
        <section
          className="section data_explore_section"
          {...getSectionProps(TABS[2].value)}
        >
          <h3 className="title_xsmall_b">{TABS[2].label}</h3>
          <div
            className="data_explore_content"
            role="group"
          >
            <h4 className="data_explore_title">{t('T40022')}</h4>
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T40023')}
            </p>
            <div className="section_container">
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T10141')}</li>
                <li className="data_item">{t('T40024')}</li>
                <li className="data_item">{t('T40025')}</li>
                <li className="data_item">{t('T40026')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40027')}</li>
                <li className="data_item">{t('T40148')}</li>
              </ul>
            </div>
          </div>
        </section>
        <div className="divider divider_thick" />
        <section
          className="section data_explore_section"
          {...getSectionProps(TABS[3].value)}
        >
          <h3 className="title_xsmall_b">{TABS[3].label}</h3>
          <div className="data_explore_content">
            <h4 className="data_explore_title">{t('T30346')}</h4>
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T40028')}
            </p>
            <div
              className="section_container"
              role="group"
            >
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40020')}</li>
                <li className="data_item">{t('T10141')}</li>
                <li className="data_item">{t('T40029')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T30054')}</li>
              </ul>
            </div>
          </div>
          <div
            className="data_explore_content"
            role="group"
          >
            <h4 className="data_explore_title">{t('T20076')}</h4>
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T40030')}
            </p>
            <div className="section_container">
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40031')}</li>
                <li className="data_item">{t('T40032')}</li>
                <li className="data_item">{t('T40034')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40035')}</li>
                <li className="data_item">{t('T40036')}</li>
              </ul>
            </div>
          </div>

          <div
            className="data_explore_content"
            role="group"
          >
            <h4 className="data_explore_title">{t('T30444')}</h4>
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T30485')}
            </p>
            <div className="section_container">
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T30486')}</li>
                <li className="data_item">{t('T30487')}</li>
                <li className="data_item">{t('T40020')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T30488')}</li>
                <li className="data_item">{t('T30489')}</li>
              </ul>
            </div>
          </div>

          <div
            className="data_explore_content"
            role="group"
          >
            <h4 className="data_explore_title">{t('T20075')}</h4>
            <p
              className="data_explore_desc"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T40037')}
            </p>
            <div className="section_container">
              <div className="data_header">
                <h5 className="data_title">{t('T40008')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T20075')}</li>
                <li className="data_item">{t('T40020')}</li>
              </ul>
              <div className="data_header">
                <h5 className="data_title">{t('T40013')}</h5>
              </div>
              <ul
                className="data_list"
                role="list"
                style={{whiteSpace: 'pre-wrap'}}
              >
                <li className="data_item">{t('T40040')}</li>
              </ul>
            </div>
          </div>
          {import.meta.env.VITE_BRAND !== BrandType.KIA && (
            <div
              className="data_explore_content"
              role="group"
            >
              <h4 className="data_explore_title">{t('T20078')}</h4>
              <p
                className="data_explore_desc"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T40041')}
              </p>
              <div className="section_container">
                <div className="data_header">
                  <h5 className="data_title">{t('T40008')}</h5>
                </div>
                <ul
                  className="data_list"
                  role="list"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  <li className="data_item">{t('T40042')}</li>
                  <li className="data_item">{t('T40043')}</li>
                  <li className="data_item">{t('T40020')}</li>
                </ul>
                <div className="data_header">
                  <h5 className="data_title">{t('T40013')}</h5>
                </div>
                <ul
                  className="data_list"
                  role="list"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  <li className="data_item">{t('T40046')}</li>
                  <li className="data_item">{t('T40047')}</li>
                  <li className="data_item">{t('T40048')}</li>
                </ul>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
}
